exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".update-company .input-group--select{margin-top:0!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Company/UpdateCompany.vue"],"names":[],"mappings":"AACA,qCACE,sBAA+B,CAChC","file":"UpdateCompany.vue","sourcesContent":["\n.update-company .input-group--select {\n  margin-top: initial !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a4545dea","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/settings/Company/UpdateCompany.vue
// module id = 1416
// module chunks = 7